
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12 3a9 9 0 100 18 9 9 0 000-18zM1 12C1 5.925 5.925 1 12 1s11 4.925 11 11-4.925 11-11 11S1 18.075 1 12zm11.258-3.976a2 2 0 00-2.224 1.308 1 1 0 01-1.887-.664 4 4 0 017.773 1.333c0 1.53-1.135 2.54-1.945 3.081a8.045 8.045 0 01-1.686.848l-.035.013-.011.003-.004.002h-.003a1 1 0 01-.633-1.896l.016-.006a5.763 5.763 0 00.364-.147c.247-.11.568-.272.882-.481.69-.46 1.055-.949 1.055-1.418v-.002a2 2 0 00-1.662-1.974zM12 16a1 1 0 100 2h.01a1 1 0 100-2H12z","fill":"#04080E"}})])
          )
        }
      }
    